const headers = {
  name: "Inventory received",
  navigate: {
    path: [
      {
        name: "Received",
        path: "/app/inventory/received",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
